module.exports = __webpack_public_path__ + "static/media/migrationIcon.5c521f66.svg";